/** True when a scroll container is within `threshold` px of its bottom edge. */
export function isNearBottom(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
  threshold = 40,
): boolean {
  return scrollHeight - (scrollTop + clientHeight) <= threshold
}
